import { GA4Event} from "./GA4Event";

export function buildBookRejected(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("book_rejected", {
		search_input: attributes.search_input || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
